/**
 * Handle toggle events
 * @param  {Event} event The Event object
 */
function toggleDetails (event) {

	// Only run if accordion is open
	if (!event.target.hasAttribute('open')) return;

	// Only run on accordions inside our selector
	let parent = event.target.closest('.data-accordion');
	if (!parent) return;

	// Get all open accordions inside parent
	let opened = parent.querySelectorAll('details[open]');

	// Close open ones that aren't current accordion
	for (let accordion of opened) {
		if (accordion === event.target) continue;
		accordion.removeAttribute('open');
	}

}

document.addEventListener('toggle', toggleDetails, true);